(function (window, $) {
	window.app.register('itemSizePicker', function ($el, options) {
		var self = this;

		$el.on('click', function(e) {
			var options = $(this).data('app-item-size-picker');
			$('.item-size-picker__button').removeClass('item-size-picker__button--active');
			$(this).addClass('item-size-picker__button--active');
			$('select[name=size]').val(options.sizeId);
		});
	}, {
		availableCommands: [

		],
	});
}(window, jQuery));